import './Dashboard.css';

type Tile = {
  href: string;
  title: string;
  blurb: string;
  external?: boolean;
};

type Group = {
  label: string;
  accent: string;
  tiles: Tile[];
};

const GROUPS: Group[] = [
  {
    label: 'Box3D physics',
    accent: '#2dd4bf',
    tiles: [
      {
        href: '/ball-lab',
        title: 'Sports Ball Lab',
        blurb: 'One tunable physics system, three balls — football, basketball, tennis.',
      },
      {
        href: '/penalty-shootout',
        title: 'Penalty Shootout',
        blurb: 'Shape the strike, watch the net answer.',
      },
      {
        href: '/wrecking-yard',
        title: 'Wrecking Yard',
        blurb: 'Wrecking ball, cannon, and boom against brick towers and castles.',
      },
      {
        href: '/castle',
        title: 'The Castle',
        blurb: 'Free-roam a procedural medieval castle — golden hour, moat, battlements.',
      },
      {
        href: '/physics-playground',
        title: 'Physics Playground',
        blurb: 'Flick, throw, and blast a stack of falling blocks.',
      },
      {
        href: '/humanoid-lab',
        title: 'Humanoid Lab',
        blurb: 'Manny, a procedural ragdoll — drop, drag, hit, pile, recover.',
      },
      {
        href: '/box3d',
        title: 'three-box3d',
        blurb: 'The open-source physics engine behind these demos.',
      },
    ],
  },
  {
    label: 'Car suite',
    accent: '#8b8bff',
    tiles: [
      {
        href: '/configurator',
        title: '3D Car Configurator',
        blurb: 'Paint, wheels, environment — a live sedan configurator.',
      },
      {
        href: '/viewer',
        title: 'Car Parts Viewer',
        blurb: 'Engine block, wheel & tire, sedan body, Blender export.',
      },
      {
        href: '/blender-lab',
        title: 'Blender Character Lab',
        blurb: 'Studio character head, staged for a render pass.',
      },
      {
        href: '/character-viewer',
        title: 'Character Viewer',
        blurb: 'Browse three open, rigged GLB characters and preview their animations.',
      },
    ],
  },
  {
    label: 'Interactive scenes',
    accent: '#e0955c',
    tiles: [
      {
        href: '/heist',
        title: 'The Vault Job',
        blurb: 'A stealth heist — grab the key, crack the vault, get out.',
      },
      {
        href: '/video-characters',
        title: 'Academy Hallway RPG',
        blurb: 'Generated video characters, clique pressure, quick-choice RPG.',
      },
      {
        href: '/worldcup',
        title: 'The Cup 26',
        blurb: 'Stadium, bracket, and shootout for a physics-real World Cup.',
      },
      {
        href: '/progress-art',
        title: 'Progress Artifact',
        blurb: 'An isometric build loop — blockout, mass, light, final.',
      },
      {
        href: '/gauntlet',
        title: 'The Gauntlet',
        blurb: "Agents' Last Exam — 100 bots per agent storm an obstacle course.",
      },
    ],
  },
  {
    label: 'Also on this server',
    accent: '#8a7a5f',
    tiles: [
      {
        href: '/codex/',
        title: 'Counterpoint',
        blurb: 'Paste a passage, get a playable point-and-click mission.',
      },
      {
        href: '/qwen/',
        title: 'Qwen Agent Society',
        blurb: 'A small society of agents, observed over time.',
      },
      {
        href: 'https://gta.swapp1990.org',
        title: 'GTA Demo',
        blurb: 'An open, drivable three.js city block.',
        external: true,
      },
    ],
  },
];

function Dashboard() {
  return (
    <div className="dash">
      <header className="dash-header">
        <div className="dash-kicker">swapp1990 / lab</div>
        <h1 className="dash-title">Three.js &amp; Box3D playground</h1>
        <p className="dash-tagline">
          A running set of three.js experiments and box3d physics demos. Pick one below.
        </p>
      </header>

      <main className="dash-body">
        {GROUPS.map((group) => (
          <section className="dash-group" key={group.label}>
            <h2 className="dash-group-label" style={{ color: group.accent }}>
              {group.label}
            </h2>
            <div className="dash-grid">
              {group.tiles.map((tile) => (
                <a
                  key={tile.href}
                  className="dash-tile"
                  href={tile.href}
                  style={{ ['--accent' as string]: group.accent }}
                  target={tile.external ? '_blank' : undefined}
                  rel={tile.external ? 'noreferrer' : undefined}
                >
                  <span className="dash-tile-title">{tile.title}</span>
                  <span className="dash-tile-blurb">{tile.blurb}</span>
                </a>
              ))}
            </div>
          </section>
        ))}
      </main>

      <footer className="dash-footer">
        <span>swapp1990.org</span>
        <span className="dash-footer-sep">·</span>
        <a href="https://github.com/swapp1990/3d-car-assembler" target="_blank" rel="noreferrer">
          source
        </a>
      </footer>
    </div>
  );
}

export default Dashboard;
